import { Grid } from '@mui/material';
import { WsTypography, WsTypoVariants } from 'wisestep-base';

import CountWithTextCard from '../../../../analytics/components/countWithTextCard';
import { useComposableDashboardsFiltersContext } from '../../../../analyticsPage/hooks/useComposableDashboardsFiltersContext';
import { JobsWidget } from '../../../DerivedCharts/helper';
import usePostgreJobWidgetsData from '../../../hooks/usePostgreJobWidgetsData';
import { IPostgreJobsDTO, IPostgreJobsWidgetProp } from '../types';
import { renderJobCountCell, defaultJobsWidgetData } from '../utils/jobsHelper';

const filterByWidget = (widgetName: JobsWidget): [string, string][] => {
  switch (widgetName) {
    case JobsWidget.METRIC_ACCEPTED:
      return [['JOB_ASSIGNMENT_STATUS', 'Accepted']];
    case JobsWidget.METRIC_ACCEPTED_NO_SUBMISSION:
      return [
        ['JOB_ASSIGNMENT_STATUS', 'Accepted'],
        [
          'SUBMISSIONS_COUNT',
          JSON.stringify({ from: 0, to: 0, includeLower: true, includeUpper: true }),
        ],
      ];
    case JobsWidget.TABLE_ACCEPTED_NO_MAPPING:
      return [['JOB_ASSIGNMENT_STATUS', 'Accepted']];
    default:
      return [];
  }
};

const JobsPostedMetricChartPostgre = ({ query, title, widgetName }: IPostgreJobsWidgetProp) => {
  const { widgetData } = usePostgreJobWidgetsData<IPostgreJobsDTO>(query, defaultJobsWidgetData);
  const { restructuredFilters } = useComposableDashboardsFiltersContext();
  const jobTypes = [
    'Permanent',
    'Contract',
    ...((widgetData.totalTemporary ?? 0) > 0 ? ['Temporary'] : []),
  ];

  return (
    <Grid container p={2}>
      <Grid item xs={12} mb={2}>
        <WsTypography variant={WsTypoVariants.TITLE} bold={true}>
          {title}
        </WsTypography>
      </Grid>
      {widgetName == JobsWidget.METRIC_TYPE_WISE ? (
        jobTypes.map((jobType) => (
          <Grid item key={jobType} xs={1} ml={10}>
            <CountWithTextCard
              variant="h4"
              count={
                renderJobCountCell(
                  {
                    value:
                      (jobType == 'Permanent'
                        ? widgetData.totalPermanent
                        : jobType == 'Contract'
                        ? widgetData.totalContract
                        : widgetData.totalTemporary) ?? 0,
                  },
                  [['JOB_TYPE', jobType]],
                  restructuredFilters,
                  query
                ) as any
              }
              fullHeight
              text={jobType}
              textVariant="caption"
            />
          </Grid>
        ))
      ) : widgetName == JobsWidget.METRIC_STATUS_WISE ? (
        ['Total', 'Open', 'Closed'].map((jobStatus) => (
          <Grid item key={jobStatus} xs={1} ml={10}>
            <CountWithTextCard
              variant="h4"
              count={
                renderJobCountCell(
                  {
                    value:
                      (jobStatus == 'Total'
                        ? widgetData.totalCount
                        : jobStatus == 'Open'
                        ? widgetData.totalOpen
                        : widgetData.totalClosed) ?? 0,
                  },
                  [['JOB_STATUS', jobStatus == 'Open' ? 'Opened' : jobStatus]],
                  restructuredFilters,
                  query
                ) as any
              }
              fullHeight
              text={jobStatus}
              textVariant="caption"
            />
          </Grid>
        ))
      ) : (
        <Grid item xs={2} ml={10}>
          <CountWithTextCard
            variant="h3"
            count={
              renderJobCountCell(
                { value: widgetData.count ?? 0 },
                filterByWidget(widgetName),
                restructuredFilters,
                query
              ) as any
            }
            fullHeight
            text=""
          />
        </Grid>
      )}
    </Grid>
  );
};

export default JobsPostedMetricChartPostgre;
